import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import "../../public/assets/css/main.css";
import { AppContext } from "../utilities/context";
import { isEmpty } from "../utilities/helpers";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";

const Ring = () => {
  const intl = useIntl();
  const urlParams = useParams();
  const [doors, setDoors] = useState([]);
  const [door, setDoor] = useState(null);
  const context = useContext(AppContext);
  const mapRef = useRef(null);
  const inputNameRef = useRef(null);
  const [sync, setSync] = useState(false);

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState(
        [
          { label: intl.formatMessage({ id: "app.header.home.label" }), url: "/" },
        ]
      );
    }
    getDoors();
  }, []);

  const getDoors = () => {
    axios
      .get(process.env.REACT_APP_API_URL + "/api/ring/")
      .then((response) => {
        setDoors(response.data);
      })
      .catch((error) => {
        setDoors([]);
        console.log(error);
      });
  };

  const RingsList = () => {
    return doors.map((d) => (
      <Grid key={"g" + d.id} item xs={12} sm={6} md={6} lg={4}>
        <Card key={"gc" + d.id} sx={{ minWidth: 275 }}>
          <CardContent key={"gcc" + d.id}>
            <Typography key={"gcckt" + d.id} variant="h6">
              {d.name}
            </Typography>
            <Typography variant="body2">
              <FormattedMessage
                id={
                  d.telegramChatId
                    ? "app.rings.syncTelegram.label"
                    : "app.rings.syncTelegramError.label"
                }
              />
            </Typography>
            <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
              {d.active ? <ToggleOnIcon color="primary" /> : <ToggleOffIcon />}
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              variant="outlined"
              component={Link}
              size="small"
              to={"/ring/" + d.id}
            >
              <FormattedMessage id="app.rings.edit.label" />
            </Button>
          </CardActions>
        </Card>
      </Grid>
    ));
  };

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" component="div">
              <FormattedMessage id="app.header.ring.label" />
            </Typography>
          </Grid>
          <RingsList />
        </Grid>
      </Container>
    </Layout>
  );
};

export default Ring;
